import "./App.css";
import { useState, useEffect } from "react";
import { Modal } from "antd";
import FloatingButton from "./components/floatingButton";
import ChatDrawer from "./components/ChatDrawer.jsx";
import { useLocalStorage } from "./useLocalStorage.js";
import { getMurphyPanelAsistente } from "./globals.js";
import { API_URL, TOKEN } from "./config";
import axios from "axios";

// import uuid v4
// import { v4 as uuidv4 } from "uuid";

const { confirm } = Modal;

function App() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useLocalStorage("messages", []);
  const [files, setFiles] = useLocalStorage("files", []);
  const [responses, setResponses] = useLocalStorage("responses", []);

  // useEffect(() => {
  //   const existingId = localStorage.getItem("conversationId");
  //   const timestamp = localStorage.getItem("conversationTimestamp");
  //   // y validar que solo sea de una hora
  //   if (!existingId) {
  //     const newId = uuidv4();
  //     localStorage.setItem("conversationId", newId);
  //     localStorage.setItem("conversationTimestamp", new Date().toISOString());
  //   } else {
  //     setMessages([]);

  //     const oneHour = 60 * 60 * 1000; // una hora en milisegundos
  //     const now = new Date();
  //     const savedTime = new Date(timestamp);
  //     if (now - savedTime > oneHour) {
  //       const newId = uuidv4();
  //       localStorage.setItem("conversationId", newId);
  //       localStorage.setItem("conversationTimestamp", new Date().toISOString());
  //     }
  //   }
  // }, []);
  useEffect(() => {
    const nav = performance.getEntriesByType("navigation")[0];
    if (nav && nav.type === "reload") {
      setMessages([]);
      setResponses([]);
      setFiles([]);
    }
    getTocken();
  }, []);

  // App.jsx
  const handleShowDrawer = async () => {
    setOpen(true);
    const onOpen = getMurphyPanelAsistente("onOpen");
    if (typeof onOpen === "function") onOpen();
    console.log("Login exitoso");
  };

  const onSessionExpired = async () => {
    await handleSessionExpiredChat();
  };

  const onClose = async () => {
    await handleClearChat();
  };

  const exitChat = () => {
    setOpen(false);
  };

  const handleSendMessage = (message) => {
    setMessages([...messages, message]);
  };

  const handleReceiveMessage = (message) => {
    setResponses([...responses, message]);
  };

  const handleSendFile = (file) => {
    setFiles([...files, file]);
  };

  const deleteSession = async () => {
    try {
      await axios.post(`${API_URL}/auth/logout`, {}, { withCredentials: true });
      console.log("Sesión eliminada correctamente");
    } catch (error) {
      console.error("Error al eliminar la sesión:", error);
    }
  };

  const getTocken = async () => {
    try {
      const response = axios.post(
        `${API_URL}/auth/login`,
        { username: "kipp" },
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );

      if (response.status === 200 || response.status === 201) {
        console.log("Login exitoso");
      }
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) {
        console.error("Login 401 (credenciales/token inválidos).");
      } else {
        console.error("Error en el login:", err);
      }
    }
  };

  // const clearId = () => {
  //   localStorage.removeItem("conversationId");
  // };

  const handleClearChat = async () => {
    if (messages.length === 0 && responses.length === 0 && files.length === 0) {
      return;
    }

    confirm({
      title: "¿Estás listo para salir del chat?",
      content: "Se cerrara la conversación y se perderán los mensajes.",
      onOk() {
        // clearId();
        deleteSession();
        setMessages([]);
        setResponses([]);
        setFiles([]);
        setOpen(false);
        getTocken();
        const onClose = getMurphyPanelAsistente("onClose");
        if (typeof onClose === "function") {
          onClose();
        }
      },
      onCancel() {},
    });
  };

  const handleSessionExpiredChat = async () => {
    Modal.info({
      title: "Sesión expirada",
      content: "La conversación se cerró automáticamente por expiración.",
      okText: "Entendido",
    });

    // Limpia el estado del chat
    deleteSession();
    setMessages([]);
    setResponses([]);
    setFiles([]);
    setOpen(false);
    getTocken();
    const onClose = getMurphyPanelAsistente("onClose");
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <div className="murphy-app">
      <FloatingButton onClick={handleShowDrawer} />
      <ChatDrawer
        open={open}
        onClose={onClose}
        messages={messages}
        responses={responses}
        files={files}
        handleSendMessage={handleSendMessage}
        handleReceiveMessage={handleReceiveMessage}
        handleSendFile={handleSendFile}
        handleClearChat={handleClearChat}
        exitChat={exitChat}
        onSessionExpired={onSessionExpired}
      />
    </div>
  );
}

export default App;
